<template>
  <div class="skeleton-root">
    <div class="coin-amount-input">
      <div class="coin-amount-input-row">
        <pseudo-skeleton width="30%" height="20px" border-radius="100px" />
        <pseudo-skeleton width="15%" height="20px" border-radius="100px" />
      </div>

      <div class="coin-amount-input-row">
        <pseudo-skeleton width="20%" height="20px" border-radius="100px" />
        <div class="coin-dropdown-skeleton">
          <base-skeleton width="20px" height="20px" border-radius="100%" />
          <base-skeleton width="40%" height="14px" border-radius="100px" />
        </div>
      </div>
    </div>

    <div class="coin-amount-input">
      <div class="coin-amount-input-row">
        <pseudo-skeleton width="30%" height="20px" border-radius="100px" />
      </div>

      <div class="coin-amount-input-row">
        <pseudo-skeleton width="20%" height="20px" border-radius="100px" />
        <div class="coin-dropdown-skeleton">
          <base-skeleton width="20px" height="20px" border-radius="100%" />
          <base-skeleton width="40%" height="14px" border-radius="100px" />
        </div>
      </div>
    </div>

    <div class="grid grid-flow-col gap-4 mt-2">
      <pseudo-skeleton
        v-for="i in skeletonLength"
        :key="i"
        width="100%"
        height="40px"
        border-radius="10px"
      />
    </div>

    <base-decoration-line class="my-10" />

    <div class="grid grid-cols-2 gap-4">
      <div class="info">
        {{ $t('b2b|common|label|rate') }}
        <svg-icon class="ml-2 text-primary-hover" name="icon_info" />
      </div>
      <div class="flex justify-end">
        <pseudo-skeleton width="40%" height="14px" border-radius="10px" />
      </div>
    </div>

    <base-button type="cta" class="mt-2" :disabled="true" size="lg">
      <span>
        {{ $t('WithdrawToWallet | actionSend') }}
      </span>
    </base-button>
  </div>
</template>

<script>
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import PseudoSkeleton from '@/shared/ui/PseudoSkeleton/PseudoSkeleton.vue'
import BaseSkeleton from '@/shared/ui/BaseSkeleton/BaseSkeleton.vue'
import BaseDecorationLine from '@/shared/ui/BaseDecorationLine/BaseDecorationLine.vue'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

export default {
  components: {
    BaseSkeleton,
    PseudoSkeleton,
    BaseDecorationLine,
    BaseButton,
    SvgIcon,
  },
  data() {
    return {
      skeletonLength: 6,
    }
  },
}
</script>

<style scoped lang="scss">
.skeleton-root {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.coin-amount-input {
  height: 120px;
  background-color: var(--bg-1);
  border: 1px solid var(--bg-35);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.coin-amount-input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.coin-dropdown-skeleton {
  justify-self: right;
  align-self: center;
  width: 100px;
  height: 36px;
  padding-left: 10px;
  background-color: #1a1a1a;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}

.info {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-4);
}
</style>
